// extracted by mini-css-extract-plugin
export default {"slider_custom":"contact_slider_custom__+qCp2","swiper_wrapper_custom":"contact_swiper_wrapper_custom__AW+4n"};